// Screens whose feature has not landed stay out of the UI for every role until
// this is on. Read only here, so a dev-mode switch can replace the env var later.
export function showComingSoon(): boolean {
  return import.meta.env.VITE_SHOW_COMING_SOON === 'true'
}
